import {ROUTES} from '@/utils/constants/routesConstants'
import ErrorContent from '@/pages/Errors/components/ErrorContent'
import {useNavigate} from 'react-router-dom'

export const PageError500 = () => {
  const navigate = useNavigate()

  const onDidClickGotoHome = () => {
    navigate(ROUTES.HOME)
    window.location.reload()
  }

  return <ErrorContent errorType="SERVER_ERROR" onClick={onDidClickGotoHome} />
}
